























































import Vue from 'vue'
import { MdButton, MdCard, MdCheckbox, MdLayout, MdSnackbar } from 'vue-material/dist/components'
import PasswordCheckEmail from '@/components/password/PasswordCheckEmail.vue'
import PasswordSendInstructions from '@/components/password/PasswordSendInstructions.vue'
import CarrusIcon from '@/assets/svgs/carrus_icon.svg?inline'

Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdCheckbox)
Vue.use(MdLayout)
Vue.use(MdSnackbar)
export default Vue.extend({
  name: 'ForgotPassword',
  data: () => ({
    email: '',
    isSubmitted: false
  }),
  components: {
    PasswordCheckEmail,
    PasswordSendInstructions,
    CarrusIcon
  },
  methods: {
    submitted (email: string): void {
      this.email = email
      this.isSubmitted = true
    },
    revert (): void {
      this.isSubmitted = false
    }
  }
})
